import firebase from "firebase";
import { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";

import { db } from "../firebase";

export default function Redir(){
    const [onPending, setonPending] = useState(false)
    const [isloggedIn, setisloggedIn] = useState(false)

    firebase.auth().onAuthStateChanged((firebaseUser) => {
        console.log(firebaseUser)
        if(firebaseUser){
          console.log("User signed in")
          setisloggedIn(true)
        } else{
          console.log("User signed out")
          setisloggedIn(false)
        }
      })

    function getOnPending(){
        if (firebase.auth().currentUser){
            db.collection('pendings').doc(firebase.auth().currentUser.uid)
                .get((doc) => {
                    console.log(doc)
                    if (doc.data()){
                        setonPending(true)
                    }
                    else{
                        setonPending(false)
                    }
                })
                .catch((error) => {
                    setonPending(true)
                    console.log(error)
                })
        }
    }

    useEffect(() => {
        getOnPending()
    }, [ isloggedIn ])

    useEffect(() => {
        console.log(onPending)
    }, [ onPending ])
    
    const displayOnPending = (
        <div>
            {onPending? <Redirect to="on-pending"></Redirect> : null}
        </div>
    )

    return(
        <div>
            {isloggedIn? 
                displayOnPending
                :
                <div>
                    <h3>You are not logged in</h3>
                </div>
            }
        </div>
    )
    

}